export default __webpack_public_path__ + "static/media/guest_19_02.b6ee3418.png";